import React from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FormattedMessage } from "react-intl";
import "./ConfirmationModal.css";
import { InputText } from "primereact/inputtext";

const ConfirmationModal = ({ show, onHide, deleteFunction, rowData }: any) => {
  const [modelName, setModelName] = React.useState(""); // State to hold the model name

  // Format button labels
  const yesLabel = <FormattedMessage id="confirm-yes" defaultMessage="Sí" />;
  const noLabel = <FormattedMessage id="confirm-no" defaultMessage="No" />;

  return (
    <Dialog
      header={
        <FormattedMessage
          id="confirm-modal-header"
          defaultMessage="Borrar Modelo"
        />
      }
      visible={show}
      onHide={onHide}
    >
      <div className="cm-input-container">
        <p className="asd">
          <FormattedMessage
            id="confirm-modal-text"
            defaultMessage="Estás seguro que quieres borrar este producto?"
          />
        </p>
        <div className="cm-input-confirm">
          <p className="cm-enter-model-p">
            <FormattedMessage
              id="confirm-enter-model"
              defaultMessage="Ingresa el nombre del Modelo"
            />
          </p>
          <InputText
            type="text"
            placeholder="Ej: MS-Guia-Superior-Masculino"
            className="cm-input-confirm"
            value={modelName}
            onChange={(e) => setModelName(e.target.value)}
          />
        </div>
      </div>
      <div className="cm-buttons-container">
        <Button
          label={yesLabel.props.defaultMessage as string} // Extract the message string from FormattedMessage
          onClick={() => {
            if (modelName === rowData.modelName) {
              deleteFunction(rowData); // Call the delete function when "Yes" is clicked
              onHide(); // Close the modal
            } else {
              // Handle error or show a message indicating incorrect model name
              console.log("Model name does not match");
            }
          }}
          className="p-button-outlined button-outline-fitprenda-common font-fitprenda-button-outline confirmation-modal-button"
        />
        <Button
          label={noLabel.props.defaultMessage as string} // Extract the message string from FormattedMessage
          onClick={onHide}
          className="p-button-outlined button-outline-fitprenda-common font-fitprenda-button-outline confirmation-modal-button"
        />
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
